import { useTranslations } from '@vocab/react';
import { Hidden, Inline, Button, IconThumb } from 'braid-design-system';
import type { FC } from 'react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';

import translations from '../.vocab';

interface NotSuitableAndShortlistButtonsProps {
  fullName: string;
  changeStatus: (bucket: BUCKETS) => Promise<void>;
}
export const NotSuitableAndShortlistButtons: FC<
  NotSuitableAndShortlistButtonsProps
> = ({ changeStatus, fullName }) => {
  const { t } = useTranslations(translations);
  return (
    <>
      <Hidden above="mobile">
        <Inline space="small">
          <Button
            tone="neutral"
            variant="ghost"
            size="small"
            aria-label={t('Move fullName to Not Suitable', {
              fullName,
            })}
            onClick={() => changeStatus(BUCKETS.NOT_SUITABLE)}
          >
            <IconThumb direction="down" />
          </Button>
          <Button
            tone="neutral"
            variant="ghost"
            size="small"
            aria-label={t('Shortlist fullName', {
              fullName,
            })}
            onClick={() => changeStatus(BUCKETS.SHORTLIST)}
          >
            <IconThumb direction="up" />
          </Button>
        </Inline>
      </Hidden>
      <Hidden below="tablet">
        <Inline space="small">
          <Button
            tone="neutral"
            variant="ghost"
            size="small"
            aria-label={t('Move fullName to Not Suitable', {
              fullName,
            })}
            onClick={() => changeStatus(BUCKETS.NOT_SUITABLE)}
            icon={<IconThumb direction="down" />}
          >
            {t('Not Suitable')}
          </Button>

          <Button
            tone="neutral"
            variant="ghost"
            size="small"
            aria-label={t('Shortlist fullName', {
              fullName,
            })}
            onClick={() => changeStatus(BUCKETS.SHORTLIST)}
            icon={<IconThumb direction="up" />}
          >
            {t('Shortlist')}
          </Button>
        </Inline>
      </Hidden>
    </>
  );
};
